import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSErrorModule, NSMultiSelectModule } from '@norfolk-southern/accessns-components';

import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { OrderHistoryHeaderComponent } from '@ruby/shared/inventory-management/order-history-header/components/order-history-header.component';
import { OrderHistoryHeaderContainer } from '@ruby/shared/inventory-management/order-history-header/containers/order-history-header.container';
import { effects, featureKey, reducer } from '@ruby/shared/inventory-management/order-history-header/store';

@NgModule({
  declarations: [
    OrderHistoryHeaderComponent,
    OrderHistoryHeaderContainer
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature(effects),
    StoreModule.forFeature(featureKey, reducer),
    MatButtonToggleModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule,
    MatButtonModule,
    NSMultiSelectModule,
    NSErrorModule,
    DirectivesModule
  ],
  exports: [OrderHistoryHeaderComponent, OrderHistoryHeaderContainer]
})
export class OrderHistoryHeaderModule {}
